import plant from './plant'
import block from './block'
import inverter_room from './inverter_room'
import inverter from './inverter'
import inverter_param from './inverter_param'
import scb from './scb'
import scb_param from './scb_param'
import zmu from './zmu'
import zmu_param from './zmu_param'
import tracker from './tracker'
import tracker_param from './tracker_param'
import breaker from './breaker'
import breaker_param from './breaker_param'
import energy_meter from './energy_meter'
import energy_meter_param from './energy_meter_param'
import mfm from './mfm'
import mfm_param from './mfm_param'
import transformer from './transformer'
import transformer_param from './transformer_param'
import ups from './ups'
import ups_param from './ups_param'
import weather_station from './weather_station'
import weather_station_param from './weather_station_param'
import fire_alarm from './fire_alarm'
import fire_alarm_param from './fire_alarm_param'
import dc_battery_charger from './dc_battery_charger'
import dc_battery_charger_param from './dc_battery_charger_param'
import annunciator from './annunciator'
import annunciator_param from './annunciator_param'
import relay from './relay'
import relay_param from './relay_param'
import soilsensor from './soilsensor'
import soilsensor_param from './soilsensor_param'
import block_overview_component from './block_overview_component'
import plant_overview_component from './plant_overview_component'
import calculated_analytics_component from './calculated_analytics_component'
import component_config from './component_config'
import daily_digest from './daily_digest'
import generation_source from './generation_source'
import aggregate_parameter_config from './aggregate_parameter_config'
import alert_config from './alert_config'
import header_components from './header_components'
import live_layout from './live_layout'
import mppt_param from './mppt_param'
import mppt_zone_status from './mppt_zone_status'
import other_sensors_components from './other_sensors_components'
import pages from './pages'
import parameter_config from './parameter_config'
import plant_device_report from './plant_device_report'
import plant_subscription from './plant_subscription'
import plant_ws_map from './plant_ws_map'
import rpi_list from './rpi_list'
import rules from './rules'
import user from './user'
import customer from './customer'
// TODO: This table doesn't seem to exist
import user_plant_config from './user_plant_config'
export default {
  map: {
    // Plant level config
    plant,
    block,
    inverter_room,
    inverter,
    inverter_param,
    scb,
    scb_param,
    zmu,
    zmu_param,
    tracker,
    tracker_param,
    energy_meter,
    energy_meter_param,
    mfm,
    mfm_param,
    weather_station,
    weather_station_param,
    breaker,
    breaker_param,
    transformer,
    transformer_param,
    ups,
    ups_param,
    fire_alarm,
    fire_alarm_param,
    annunciator,
    annunciator_param,
    dc_battery_charger,
    dc_battery_charger_param,
    relay,
    relay_param,
    block_overview_component,
    plant_overview_component,
    calculated_analytics_component,
    component_config,
    daily_digest,
    generation_source,
    aggregate_parameter_config,
    alert_config,
    header_components,
    live_layout, 
    mppt_param,
    mppt_zone_status,
    other_sensors_components,
    pages,
    parameter_config,
    plant_device_report,
    plant_subscription,
    plant_ws_map,
    rpi_list,
    rules,
    soilsensor,
    soilsensor_param,
    tracker,
    tracker_param,
    // Plant level config
    user,
    user_plant_config,
    customer
  },
  components: {
    plant: [
      {
        component: 'block',
        name: 'Block',
      },
      {
        component: 'inverter_room',
        name: 'Room',
      },
      {
        component: 'inverter',
        name: 'Inverter',
      },
      {
        component: 'scb',
        name: 'SCB',
      },
      {
        component: 'energy_meter',
        name: 'Energy Meter',
      },
      {
        component: 'mfm',
        name: 'MFM',
      },
      {
        component: 'weather_station',
        name: 'Weather Station',
      },
      {
        component: 'breaker',
        name: 'Breaker',
      },
      {
        component: 'transformer',
        name: 'Transformer',
      },
      {
        component: 'ups',
        name: 'UPS',
      },
      {
        component: 'zmu',
        name: 'ZMU',
      },
      {
        component: 'tracker',
        name: 'Tracker',
      },
      {
        component: 'fire_alarm',
        name: 'Fire Alarm',
      },
      {
        component: 'dc_battery_charger',
        name: 'DC Battery Charger',
      },
      {
        component: 'breaker',
        name: 'Breaker',
      },
      {
        component: 'annunciator',
        name: 'Annunciator',
      },
      {
        component: 'soilsensor',
        name: 'Soil Sensor',
      },
      {
        component: 'relay',
        name: 'Relay',
      },
      {
        component: 'rpi_list',
        name: 'RPI List',
      },
      {
        component: 'plant_ws_map',
        name: 'Plant WS Map',
      },
      {
        component: 'plant_subscription',
        name: 'Plant Subscription',
      },
      {
        component: 'plant_device_report',
        name: 'Plant Device Report',
      },
      {
        component: 'pages',
        name: 'Pages',
      },
      {
        component: 'other_sensors_components',
        name: 'Other Sensor Component',
      },
      // { TODO: this  table does not exist
      //   component: 'mppt_zone_status',
      //   name: 'MPPT Zone Status',
      // },
      {
        component: 'mppt_param',
        name: 'MPPT Param',
      },
      {
        component: 'live_layout',
        name: 'Live Layout',
      },
      {
        component: 'header_components',
        name: 'Header Components',
      },
      {
        component: 'alert_config',
        name: 'Alert Config',
      },
      {
        component: 'generation_source',
        name: 'Generation Source',
      },
      {
        component: 'daily_digest',
        name: 'Daily Digest',
      },
      {
        component: 'component_config',
        name: 'Component Config',
      },
      {
        component: 'calculated_analytics_component',
        name: 'Calculated Analytics Component',
      },
      {
        component: 'plant_overview_component',
        name: 'Plant Overview Component',
      },
      {
        component: 'block_overview_component',
        name: 'Block Overview Component',
      },
    ],
    user: [
      {
        component: 'user',
        name: 'User',
      },
      {
        component: 'user_plant_config',
        name: 'User Plant Config',
      },
    ],
    global: [
      {
        component: 'rules',
        name: 'Rules',
      },
      {
        component: 'parameter_config',
        name: 'Parameter Config',
      },
      {
        component: 'aggregate_parameter_config',
        name: 'Aggregate Paramter Config',
      },
      {
        component: 'customer',
        name: 'Customer',
      },
    ]
  }
}
